// src/reducers/hdfcCardReducers.js
import {
  GET_ALL_HDFC_CARD_REQUEST,
  GET_ALL_HDFC_CARD_SUCCESS,
  GET_ALL_HDFC_CARD_FAIL,
  CREATE_HDFC_CARD_REQUEST,
  CREATE_HDFC_CARD_SUCCESS,
  CREATE_HDFC_CARD_FAIL,
  UPDATE_HDFC_CARD_REQUEST,
  UPDATE_HDFC_CARD_SUCCESS,
  UPDATE_HDFC_CARD_FAIL,
  DELETE_HDFC_CARD_REQUEST,
  DELETE_HDFC_CARD_SUCCESS,
  DELETE_HDFC_CARD_FAIL,
  BULK_DELETE_HDFC_CARD_REQUEST,
  BULK_DELETE_HDFC_CARD_SUCCESS,
  BULK_DELETE_HDFC_CARD_FAIL,
  IMPORT_HDFC_CARD_REQUEST,
  IMPORT_HDFC_CARD_SUCCESS,
  IMPORT_HDFC_CARD_FAIL,
  EXPORT_HDFC_CARD_REQUEST,
  EXPORT_HDFC_CARD_SUCCESS,
  EXPORT_HDFC_CARD_FAIL,
  GET_HDFC_CARD_DEPARTMENTS_REQUEST,
  GET_HDFC_CARD_DEPARTMENTS_SUCCESS,
  GET_HDFC_CARD_DEPARTMENTS_FAIL,
} from "../constants/hdfccardConstants";

// Get HDFC Card Records Reducer
export const getHdfcCardRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_HDFC_CARD_REQUEST:
      return { loadingGetHdfcCardRecords: true };
    case GET_ALL_HDFC_CARD_SUCCESS:
      return {
        loadingGetHdfcCardRecords: false,
        getHdfcCardRecordsData: action.payload,
      };
    case GET_ALL_HDFC_CARD_FAIL:
      return {
        loadingGetHdfcCardRecords: false,
        errorGetHdfcCardRecords: action.payload,
      };
    default:
      return state;
  }
};

// Create HDFC Card Reducer
export const createHdfcCardReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_HDFC_CARD_REQUEST:
      return { loading: true };
    case CREATE_HDFC_CARD_SUCCESS:
      return { loading: false, success: true, record: action.payload };
    case CREATE_HDFC_CARD_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Update HDFC Card Reducer
export const updateHdfcCardReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_HDFC_CARD_REQUEST:
      return { loadingUpdateHdfcCard: true };
    case UPDATE_HDFC_CARD_SUCCESS:
      return {
        loadingUpdateHdfcCard: false,
        updateHdfcCardData: action.payload,
      };
    case UPDATE_HDFC_CARD_FAIL:
      return {
        loadingUpdateHdfcCard: false,
        errorUpdateHdfcCard: action.payload,
      };
    default:
      return state;
  }
};

// Delete HDFC Card Reducer
export const deleteHdfcCardReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_HDFC_CARD_REQUEST:
      return { loading: true };
    case DELETE_HDFC_CARD_SUCCESS:
      return { loading: false, success: true };
    case DELETE_HDFC_CARD_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Bulk Delete HDFC Card Reducer
export const bulkDeleteHdfcCardReducer = (state = {}, action) => {
  switch (action.type) {
    case BULK_DELETE_HDFC_CARD_REQUEST:
      return { loadingBulkDeleteHdfcCard: true };
    case BULK_DELETE_HDFC_CARD_SUCCESS:
      return {
        loadingBulkDeleteHdfcCard: false,
        bulkDeleteHdfcCardData: action.payload,
      };
    case BULK_DELETE_HDFC_CARD_FAIL:
      return {
        loadingBulkDeleteHdfcCard: false,
        errorBulkDeleteHdfcCard: action.payload,
      };
    default:
      return state;
  }
};

// Import HDFC Card Reducer
export const importHdfcCardReducer = (state = {}, action) => {
  switch (action.type) {
    case IMPORT_HDFC_CARD_REQUEST:
      return { loadingImportHdfcCard: true };
    case IMPORT_HDFC_CARD_SUCCESS:
      return {
        loadingImportHdfcCard: false,
        importHdfcCardData: action.payload,
      };
    case IMPORT_HDFC_CARD_FAIL:
      return {
        loadingImportHdfcCard: false,
        errorImportHdfcCard: action.payload,
      };
    default:
      return state;
  }
};

// Export HDFC Card Reducer
export const exportHdfcCardReducer = (state = {}, action) => {
  switch (action.type) {
    case EXPORT_HDFC_CARD_REQUEST:
      return { loadingExportHdfcCard: true };
    case EXPORT_HDFC_CARD_SUCCESS:
      return {
        loadingExportHdfcCard: false,
        exportHdfcCardData: action.payload,
      };
    case EXPORT_HDFC_CARD_FAIL:
      return {
        loadingExportHdfcCard: false,
        errorExportHdfcCard: action.payload,
      };
    default:
      return state;
  }
};

// Get HDFC Card Departments Reducer
export const getHdfcCardDepartmentsReducer = (
  state = { departments: [] },
  action,
) => {
  switch (action.type) {
    case GET_HDFC_CARD_DEPARTMENTS_REQUEST:
      return { loading: true, departments: [] };
    case GET_HDFC_CARD_DEPARTMENTS_SUCCESS:
      return { loading: false, departments: action.payload };
    case GET_HDFC_CARD_DEPARTMENTS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
